export default "__VITE_ASSET__c4700856__"